"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableRowProperties = void 0;
var table_row_properties_1 = require("../../../../../core/model/tables/properties/table-row-properties");
var table_units_1 = require("../../../../../core/model/tables/secondary-structures/table-units");
var table_floating_position_info_1 = require("./table-floating-position-info");
var RtfTableRowProperties = (function () {
    function RtfTableRowProperties() {
        this.left = 0;
        this.widthBefore = table_units_1.TableWidthUnit.createDefault();
        this.widthAfter = table_units_1.TableWidthUnit.createDefault();
        this.gridBefore = 0;
        this.gridAfter = 0;
        this.height = table_units_1.TableHeightUnit.createDefault();
        this.coreProperties = new table_row_properties_1.TableRowProperties();
        this.cellSpacing = table_units_1.TableWidthUnit.createDefault();
        this.floatingPosition = new table_floating_position_info_1.TableFloatingPositionInfo();
    }
    RtfTableRowProperties.prototype.copyFrom = function (obj) {
        this.coreProperties.copyFrom(obj.coreProperties);
        this.left = obj.left;
        this.foreColorIndex = obj.foreColorIndex;
        this.backColorIndex = obj.backColorIndex;
        this.cellSpacing.copyFrom(obj.cellSpacing);
        this.floatingPosition = obj.floatingPosition;
        this.shadingPattern = obj.shadingPattern;
        this.foreColor = obj.foreColor;
        this.backColor = obj.backColor;
        this.widthAfter = obj.widthAfter;
        this.widthBefore = obj.widthBefore;
        this.gridBefore = obj.gridBefore;
        this.gridAfter = obj.gridAfter;
        this.height = obj.height;
    };
    RtfTableRowProperties.prototype.apply = function (row) {
        row.widthBefore = this.widthBefore;
        row.widthAfter = this.widthAfter;
        row.gridBefore = this.gridBefore;
        row.gridAfter = this.gridAfter;
        row.height = this.height;
    };
    return RtfTableRowProperties;
}());
exports.RtfTableRowProperties = RtfTableRowProperties;
